import { isPluginDefinition, type PluginDefinition } from "@saludio/core";

const PLUGIN_STORAGE_KEY = "plugin-storage";

export const PluginSettingsStorage = {
  getDefs: (): Array<PluginDefinition> => {
    try {
      const raw = localStorage.getItem(PLUGIN_STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.filter(isPluginDefinition);
    } catch {
      return [];
    }
  },
  setDefs: (defs: Array<PluginDefinition>): void => {
    localStorage.setItem(PLUGIN_STORAGE_KEY, JSON.stringify(defs));
  },
  clear: (): void => {
    localStorage.removeItem(PLUGIN_STORAGE_KEY);
  },
};
